import React from "react";
import { Table, Text } from "@mantine/core";
import moment from "moment";

const AgingReportView = ({ rows = [] }) => (
  <>
    <Table striped withBorder>
      <thead>
        <tr>
          <th>Counterparty</th>
          <th>Document</th>
          <th>Entry Date</th>
          <th>Days</th>
          <th>Bucket</th>
          <th>Open Amount</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row._id || `${row.documentCode}-${row.entryDate}`}>
            <td>{row.counterpartyLabel}</td>
            <td>{row.documentCode}</td>
            <td>{row.entryDate ? moment(row.entryDate).format("LL") : ""}</td>
            <td>{row.days}</td>
            <td>{row.bucket}</td>
            <td>{row.openAmount}</td>
            <td>{row.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    {rows.length === 0 && (
      <Text size="sm" color="dimmed" mt="md">
        No aging data for the selected criteria.
      </Text>
    )}
  </>
);

export default AgingReportView;
